
<template>
  <div>
    <v-row justify="space-around" >
      <v-col cols='5'>
        <v-text-field readonly label="Pago em" :value="info.payed"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Confirmado em" :value="info.confirmed"></v-text-field>
      </v-col>
      <v-col cols='6'>
        <v-text-field readonly label="Confirmado por" :value="info.confirmed_by"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Depositado em" :value="info.deposited_date"></v-text-field>
      </v-col>
    </v-row>
    <v-container grid-list-xl>
      <v-text-field readonly label="Banco" :value="info.bank"></v-text-field>
      <v-text-field readonly label="Agencia" :value="info.whole_agency"></v-text-field>
      <v-text-field readonly label="Conta" :value="info.whole_account"></v-text-field>
      <v-text-field readonly label="Num. Cheque" :value="info.check_number"></v-text-field>
      <v-text-field readonly label="Bom para" :value="info.good_to"></v-text-field>
      <v-text-field readonly label="Valor" :value="Number(info.value).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})"></v-text-field>
      <v-text-field readonly label="Nominal" :value="info.nominal"></v-text-field>
      <v-text-field readonly label="CPF Nominal" v-mask="'###.###.###-##'" :value="info.nominal_cpf" v-if="info.nominal_cpf"></v-text-field>
      <v-text-field readonly label="CNPJ Nominal" v-mask="'##.###.###/####-##'" :value="info.nominal_cnpj" v-if="info.nominal_cnpj"></v-text-field>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'InfoCheck',
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>